"use client"
import React from 'react'
import MainDashboard from '../../components/client/dashboard/MainDashboard';
import Navbar from '../../components/client/common/Navbar';

const Dashboard = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainDashboard/>
      </main>
    </div>  
  )
}

export default Dashboard
